import { useSyncExternalStore } from 'react';
import type { CustomValueNotifier } from './customValueNotifier';

/**
 * Аналог `ValueListenableBuilder` — подписывает компонент на
 * [CustomValueNotifier].
 */
export function useValueNotifier<T>(notifier: CustomValueNotifier<T>): T {
  return useSyncExternalStore(
    notifier.subscribe,
    notifier.getSnapshot,
    notifier.getSnapshot,
  );
}
